import { Link } from "react-router-dom";
import { Heart, Instagram, Youtube, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-neutral-950 text-neutral-300 mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-brand-pink/20">
              <Heart className="w-4 h-4 text-brand-pink" fill="#E91E63" />
            </span>
            <div className="leading-tight">
              <div className="font-display text-xl text-white">Host <span className="font-script text-brand-pink">Hustle</span></div>
              <div className="text-[10px] tracking-[0.22em] uppercase text-neutral-500">Smarter Hosting. Higher Returns.</div>
            </div>
          </div>
          <p className="text-sm text-neutral-400 leading-relaxed">
            Built by <span className="text-white">Kristy</span>, powered by BNB Co-Host Academy. The complete education platform for Airbnb hosts, co-hosts and property managers.
          </p>
          <p className="text-[10px] text-neutral-500 mt-4 leading-relaxed">
            Host Hustle is an independent educational company and is not affiliated with or endorsed by Airbnb, Inc.
          </p>
        </div>

        <div>
          <div className="text-white font-medium mb-4 text-sm tracking-widest uppercase">Learn</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/courses" className="hover:text-brand-pink">Courses</Link></li>
            <li><Link to="/free-resources" className="hover:text-brand-pink">Free Resources</Link></li>
            <li><Link to="/toolbox" className="hover:text-brand-pink">Toolbox</Link></li>
            <li><Link to="/coaching" className="hover:text-brand-pink">Coaching</Link></li>
            <li><Link to="/ai-tools" className="hover:text-brand-pink">AI Tools</Link></li>
            <li><Link to="/ask-coach" className="hover:text-brand-pink">Ask Host Hustle</Link></li>
            <li><Link to="/calculators" className="hover:text-brand-pink">Calculators</Link></li>
            <li><Link to="/community" className="hover:text-brand-pink">Community</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-white font-medium mb-4 text-sm tracking-widest uppercase">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-brand-pink">About Kristy</Link></li>
            <li><Link to="/community" className="hover:text-brand-pink">Success Stories</Link></li>
            <li><Link to="/community" className="hover:text-brand-pink">Blog</Link></li>
            <li><Link to="/community" className="hover:text-brand-pink">Speaking</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-white font-medium mb-4 text-sm tracking-widest uppercase">Connect</div>
          <div className="flex gap-3 mb-4">
            <a href="#" className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:border-brand-pink hover:text-brand-pink" aria-label="Instagram"><Instagram className="w-4 h-4" /></a>
            <a href="#" className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:border-brand-pink hover:text-brand-pink" aria-label="Youtube"><Youtube className="w-4 h-4" /></a>
            <a href="#" className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:border-brand-pink hover:text-brand-pink" aria-label="Facebook"><Facebook className="w-4 h-4" /></a>
          </div>
          <p className="text-xs text-neutral-500">contact@hosthustle.com</p>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between text-xs text-neutral-500">
          <div>© {new Date().getFullYear()} Host Hustle. All rights reserved.</div>
          <div className="mt-2 md:mt-0 tracking-widest uppercase">Better Hosting · Higher Returns · More Freedom</div>
        </div>
      </div>
    </footer>
  );
}
